import { jsx as _jsx } from "react/jsx-runtime";
import { DropdownButton, DropdownButtonContext } from '@dixa/lib-shared-habla';
import { useContext, useEffect, useMemo, useState } from 'react';
import { analytics } from 'app/utils/segment';
import { ConversationContext } from 'components/conversation/components/ConversationProvider';
import { TranslateTextLanguageSelectionList } from 'components/translateTextLanguageSelectionList';
export const ConversationTranslate = () => {
    const [selectedLanguageCode, setSelectedLanguageCode] = useState(undefined);
    const { setTranslationLanguageCode } = useContext(ConversationContext);
    useEffect(() => {
        setTranslationLanguageCode === null || setTranslationLanguageCode === void 0 ? void 0 : setTranslationLanguageCode(selectedLanguageCode);
    }, [selectedLanguageCode, setTranslationLanguageCode]);
    const dropdown = useMemo(() => (_jsx(DropdownButtonContext.Consumer, { children: (dropdownProps) => (_jsx(TranslateTextLanguageSelectionList, { autoFocusSearch: dropdownProps.dropdownOpen, selectedLanguageCode: selectedLanguageCode, onRevert: () => setSelectedLanguageCode(undefined), onLanguageChange: (event) => {
                if (event.selectedLanguage) {
                    analytics.agentCopilotTranslateMessageLanguageSelected({
                        language: event.selectedLanguage.name,
                        context: 'allMessages',
                    });
                    setSelectedLanguageCode(event.selectedLanguage.code);
                    dropdownProps.closeDropdown();
                }
            } })) })), []);
    return (_jsx(DropdownButton, Object.assign({ dropdown: dropdown, icon: "translate" }, { children: "Translate" })));
};
